import { requestGet, requestPost } from '@/utils/request'

export function likeAdd(params){
  return requestPost('/person/like/add', params);
}
